import React from 'react';
import { SettingsContext } from './SettingsContext';
import { EcomSettings } from '../../Providers/WaykeItemProvider';
import { PublicApiSettings } from '../../../../Gql/config';

interface SettingsProps {
  ecomSettings?: EcomSettings;
  googleMapsApiKey?: string;
  googleMapsMarker?: string;
  apiUrl?: string;
  publicApi?: PublicApiSettings;
  children: React.ReactNode;
}

const SettingsProvider = ({
  googleMapsApiKey,
  googleMapsMarker,
  ecomSettings,
  apiUrl,
  publicApi,
  children,
}: SettingsProps) => (
  <SettingsContext.Provider
    value={{ ecomSettings, googleMapsApiKey, googleMapsMarker, apiUrl, publicApi }}
  >
    {children}
  </SettingsContext.Provider>
);

export default SettingsProvider;
